import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import {Package} from "../../../model/package";
import {PropertyFormComponent} from "../property-form/property-form.component";
import {Router} from "@angular/router";
import {ProductsContainerComponent} from "../products-container/products-container.component";
import {Property} from "../../../model/property";
import {DropzoneComponent} from "../../dropzone/dropzone.component";
import {Document} from "../../../model/document";
import {ProductsContainerMobileComponent} from "../products-container-mobile/products-container-mobile.component";
import {ProductService} from "../../../service/product.service";
import {User} from "../../../model/user";
import {PlatformService} from "../../../service/platform.service";
import {AuthGuard} from "../../../guards/auth.guard";
import {NewOrderPageConnectComponent} from "../new-order-page-connect/new-order-page-connect.component";
import {FormBuilder, FormGroup, UntypedFormArray, Validators} from "@angular/forms";
import {ContactService} from "../../../service/contact.service";
import {ViewportScroller} from "@angular/common";
import {forkJoin} from "rxjs";
import { LoginIdService } from "../../../service/login-id.service";
import {AuthorityService} from "../../../service/authority.service";
import {Landregisterfolio} from "../../../model/landregisterfolio";
import {faBuilding, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {ParcelMapComponent} from "../parcel-map/parcel-map.component";
import FormUtils from "../../../utils/form-utils";
import {Flur} from "../../../model/flur";
import {InformationPopupComponent} from "../../information-popup/information-popup.component";
import {MatDialog} from "@angular/material/dialog";
import {PricingUtils} from "../../../utils/pricing-utils";
import {v4 as uuid} from "uuid";
import {LandregisterfolioUtils} from "../../../utils/LandregisterfolioUtils";

@Component({
  selector: 'app-new-order-page',
  templateUrl: './new-order-page.component.html',
  styleUrls: ['./new-order-page.component.css']
})
export class NewOrderPageComponent implements OnInit, AfterViewInit {

  property: Property;
  properties: Array<Property> = new Array<Property>();
  packages: Array<Package>;
  @ViewChild(ParcelMapComponent) parcelMapComponent: ParcelMapComponent;
  @ViewChild(PropertyFormComponent) propertyFormComponent: PropertyFormComponent;
  @ViewChild(ProductsContainerComponent) productsContainerComponent: ProductsContainerComponent;
  @ViewChild(ProductsContainerMobileComponent) productsContainerMobileComponent: ProductsContainerMobileComponent;
  @ViewChild(DropzoneComponent) dropzoneComponent: DropzoneComponent;
  displayInfo: boolean = false;
  user: User;
  docInfo: string;
  extraDocuments: boolean = false;
  legitimateInterest: string = "init";
  files: Array<any>;
  documents: Array<Document> = new Array<Document>();
  toNextPage: boolean = false;
  errorMsg: string;
  mobile: boolean = false;
  showContactSupportModal: boolean = false;
  showContactForm: boolean = false;
  platformProfile;
  showMissingPropertyError: boolean = false;
  isAllowedToOrder: boolean = true;
  isManualObjectDataInput: boolean = false;
  isMapLoading: boolean = false;
  propertyInformationForm: FormGroup
  researchAmount: number;

  protected readonly faBuilding = faBuilding;
  protected readonly faQuestionCircle = faQuestionCircle;
  protected readonly FormUtils = FormUtils;

  constructor(private readonly router: Router, private readonly productService: ProductService,
              private readonly cd: ChangeDetectorRef, private readonly platformService: PlatformService,
              private readonly contactService: ContactService, private readonly scroll: ViewportScroller,
              private readonly loginIdService: LoginIdService, private readonly authorityService: AuthorityService,
              private readonly formBuilder: FormBuilder, private readonly dialog: MatDialog) {
    let legitimateInterest = JSON.parse(sessionStorage.getItem("legitimate_interest"));
    this.legitimateInterest = legitimateInterest ?? this.legitimateInterest;
  }

  async ngOnInit(): Promise<void> {
    this.initializePropertyInformationForm();
    await this.loginIdService.loginServiceInitialized$.toPromise();
    this.openInformationModal();
    this.researchAmount = PricingUtils.getResearchAmount();
    //TODO: Performance Optimization: Clear the currently selected properties when changing the multi user => loginIdSub?
    this.isAllowedToOrder = this.loginIdService.isAdmin() || this.loginIdService.canOrder();

    this.loadPropertiesFromSession();
    this.handleInitialPropertySelection();

    this.user = JSON.parse(sessionStorage.getItem("user"));
  }

  ngAfterViewInit(): void {
    this.platformProfile = JSON.parse(sessionStorage.getItem("platform"))

    if (!this.platformProfile) {
      forkJoin([
        this.platformService.getPlatformprofile({}, 'PLATFORM_CONNECT_BASE_VIEW'),
        this.platformService.getPlatformprofile({}, 'PLATFORM_CONNECT_PROPERTIES_VIEW')
      ]).subscribe(([profile, propertiesProfile]) => {
        profile.properties = propertiesProfile.properties;
        sessionStorage.setItem("platform", JSON.stringify(profile));
        this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));
        if (!this.platformProfile) {
          this.showContactSupportModal = true;
        } else {
          this.setNewOrderPageComponent(this.platformProfile.platformType)
        }
      }, () => {
        this.showContactSupportModal = true;
      })
    }
  }

  setNewOrderPageComponent(platformType: string) {
    if (platformType === 'CONNECT') {
      this.removeNewOrderPageComponentFromRouterConfig();
      this.router.config.unshift({
        path: 'new_order',
        component: NewOrderPageConnectComponent,
        canActivate: [AuthGuard]
      });
    } else {
      this.removeNewOrderPageComponentFromRouterConfig();
      this.router.config.unshift({path: 'new_order', component: NewOrderPageComponent, canActivate: [AuthGuard]});
    }
    this.router.navigateByUrl('/new_order')
  }

  removeNewOrderPageComponentFromRouterConfig() {
    let index = this.router.config.findIndex(route => route.path === 'new_order');
    this.router.config.splice(index, 1)
  }

  setDocuments(documents) {
    let documentObjects = []
    documents.forEach(function (document) {
      documentObjects.push(new Document(document));
    })
    this.getProductContainer().documents = documentObjects;
  }

  /**
   * Handles the authority flow, either navigating to the next page or staying on the current one,
   * depending on form validity and the user's intent.
   *
   * @param toNextPage - Whether to proceed to the authority page.
   */
  public addAuthority(toNextPage: boolean): void {
    this.toNextPage = toNextPage;
    this.productsContainerComponent.resetSelectedPackage();

    const isValid = this.isFormValid() && this.propertyInformationForm.valid;
    const isEmpty = this.isObjectInformationEmpty();

    if (!isValid && toNextPage && isEmpty) {
      this.router.navigate(['/authority']);
      return;
    }

    if (!isValid) return;

    // Make sure to save the current folios before resetting since they are needed for clearing the parcel map later
    const propertyFolios = this.property.landregisterfolios

    // Common logic for both cases
    this.saveOrUpdateProperty();
    this.storeInSession();

    if (toNextPage) {
      this.authorityService.setLastPropertyHash(this.propertyFormComponent.propertyForm.value);
      this.router.navigate(['/authority']);
    } else {
      if (this.parcelMapComponent) {
        this.clearParcelMap(propertyFolios);
      }
      this.scroll.scrollToPosition([0, 0]);
    }
  }

  /**
   * Clears the parcel map by sending a postMessage to reset the map with updated parcel data.
   *
   */
  private clearParcelMap(landregisterfolios: Landregisterfolio[]){
    const landregisterfolioParcelString = this.buildFolioParcelStrings(landregisterfolios)
    this.parcelMapComponent.iframe.nativeElement.contentWindow.postMessage({type: 'resetMap', payload: {parcels: landregisterfolioParcelString}}, '*');
  }

  getProductContainer() {
    if (this.productsContainerComponent) {
      return this.productsContainerComponent;
    } else if (this.productsContainerMobileComponent) {
      return this.productsContainerMobileComponent;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  storeInSession() {
    sessionStorage.setItem("new_order_properties", JSON.stringify(this.properties));
  }

  compareLists(listA, listB) {
    if (listA.length != listB.length)
      return false;

    listA.forEach(function (elem) {
        if (!listB.includes(elem))
          return false;
      }
    )
    return true;
  }

  displayInfoEvent(docName) {
    this.addInfos(docName);
  }

  addInfos(name) {
    this.productService.getInfoProductCommand(name).subscribe(
      data => {
        this.docInfo = data
        this.displayInfo = true;
      },
      error => {
        console.log(error);
      });
  }

  /**
   * Saves or updates a property based on the form inputs.
   * If the property does not already exist, creates a new property and assigns a unique ID.
   * Otherwise, updates the existing property with the merged form values.
   *
   * The method also resets the property and related forms after handling the operation.
   */
  private saveOrUpdateProperty(): void {
    const propertyForm = this.propertyFormComponent.propertyForm;
    const propertyValues = propertyForm.value;
    const infoValues = this.propertyInformationForm.value;

    const mergedValues = {
      ...propertyValues,
      name: infoValues.name,
      dataResearch: infoValues.dataResearch,
      dataSource: this.isManualObjectDataInput ? 'manual' : 'map'
    };

    if (!this.propertyFormComponent.property.id) {
      // Create a new property
      const newProperty: Property = {
        ...this.property,
        ...mergedValues,
        id: uuid(),
        documents: this.getProductContainer().documents
      };
      newProperty.dataResearch = infoValues.dataResearch;
      this.properties.push(newProperty);
      this.property = newProperty;
    } else {
      // Update existing property
      const existing = this.properties.find(p => p.id === this.propertyFormComponent.property.id);
      if (existing) {
        Object.assign(existing, mergedValues);
        if (this.platformProfile.platformType === "STEUER") {
          existing.taxNumber = propertyValues.taxNumber;
        }
      }
    }
    this.resetProperty();
  }

  /**
   * Resets the form and component state regarding the property
   * - Re-initializes the property object
   * - Clears documents in the productsContainerComponent
   * - Resets the property form
   */
  resetProperty() {
    let propertyForm = this.propertyFormComponent.propertyForm;
    this.property = new Property('map');
    this.productsContainerComponent.documents = [];
    propertyForm.reset();
    this.propertyInformationForm.reset();
  }

  /**
   * Handles the selection of a property. Updates relevant data and UI components based on the selected property.
   *
   * @param {Object} property - The property object that has been selected.
   */
  public onPropertySelection(property): void {
    this.property = property;
    this.getProductContainer().documents = this.property.documents;
    this.updateManualDataInput(this.property.dataSource === 'manual', false, this.property.dataResearch);

    if(property.id && !this.isManualObjectDataInput){
      this.isMapLoading = true;
    }

    this.productsContainerComponent.findNextDocumentPackage();
    this.updateMapData();
    this.propertyInformationForm.patchValue({
      dataResearch: this.property?.dataResearch ?? false,
      name: this.property?.name ?? ''
    })
    // use setTimeout here to ensure thet the PropertyFormComponent is initialized in the view
    setTimeout(() => {
      this.propertyFormComponent?.updateFormFromProperty();
    });
  }

  removePropertyFromPropertyList(property) {
    this.properties.forEach((p, index) => {
      if (p === property)
        this.properties.splice(index, 1);
      if (this.isPropertyLoaded(property)) {
        this.onPropertySelection(new Property('map'));
      }
      this.clearParcelMap(property.landregisterfolios);
    });
  }

  isPropertyLoaded(property) {
    return this.property === property;
  }

  /**
   * Determines if the propertyForm of the propertyFormComponent contains no values and if there is at least one property in this.properties
   *
   * @return True if the property form contains only empty values and if there is at least one property in this.properties else false
   */
  public isObjectInformationEmpty(): boolean {
    let propertyFormValue = this.propertyFormComponent.propertyForm.value;
    return !propertyFormValue.name && !propertyFormValue.street && !propertyFormValue.house_number && !propertyFormValue.zip && !propertyFormValue.town && this.properties.length > 0;
  }
  /**
   * Validates the state of the form and checks if all required conditions are met.
   *
   * The method performs the following validations:
   * 1. Ensures that required parcels are selected if manual object data input is not enabled
   *    and no data research is enabled.
   * 2. Ensures that the property form is valid.
   * 3. Ensures that at least one document is selected.
   *
   * If any of these checks fail, it sets an appropriate error message and returns false.
   * If all checks pass, it clears the error message and returns true.
   *
   * @return {boolean} True if the form is valid, otherwise false.
   */
  isFormValid(): boolean {
    const propertyForm = this.propertyFormComponent.propertyForm;
    const hasParcels = this.buildFolioParcelStrings(this.property?.landregisterfolios ?? []).length > 0;
    const dataResearchEnabled = this.propertyInformationForm.get("dataResearch")?.value;
    const documents = this.getProductContainer().documents;

    // Case 1: Parcel selection required but missing
    if (!this.isManualObjectDataInput && !hasParcels && !dataResearchEnabled) {
      this.errorMsg = "Bitte wählen Sie die relevanten Flurstücke auf der Karte aus.";
      return false;
    }

    // Case 2: Property form invalid
    if (!propertyForm.valid) {
      this.errorMsg = "Bitte geben Sie alle relevanten Objektdaten an.";
      return false;
    }

    // Case 3: No documents selected
    if (documents.length === 0) {
      this.errorMsg = "Bitte wählen Sie mindestens ein Dokument aus.";
      return false;
    }

    // All validations passed
    this.errorMsg = null;
    return true;
  }

  setShowContactForm() {
    this.showContactForm = true;
  }

  checkIfPropertyIsSelected() {
    let propertyForm = this.propertyFormComponent.propertyForm;

    if (!propertyForm.value.zip || !propertyForm.value.town || !propertyForm.value.street) {
      this.showMissingPropertyError = true;
      this.productsContainerComponent.documents = [];
      this.productsContainerComponent.resetSelectedPackage();
      this.productsContainerComponent.shouldOpenModal = false;
      propertyForm.get('zip').markAsTouched();
      propertyForm.get('town').markAsTouched();
      propertyForm.get('street').markAsTouched();
    } else {
      this.showMissingPropertyError = false;
      this.productsContainerComponent.shouldOpenModal = true;
    }
  }

  /**
   * Retrieves the country state name and service information (on site obtaining) for the current property in the property form and updates the form with the retrieved values.
   * If an error occurs a default value for on site obtaining is set (true).
   * Automatically re-adds a teilung docuemnt if present to the current property to make sure the teilungInformationModal is shown
   * when the on site obtaining flag was updated.
   */
  public checkPropertyInForm(): void{
    let propertyForm = this.propertyFormComponent.propertyForm;
    (document.activeElement as HTMLElement).blur();
    let property: Property = propertyForm.value;

    if(!this.hasFullAddress){
      return;
    }

    // Observables for retrieving the country state name and service information for current property
    const countryStateObservable = this.contactService.getCountryStateName(property.town, property.zip);
    const serviceInformationObservable = this.contactService.getPropertyServiceInformationForTeilun(property);

    // Execute both observables parallel
    forkJoin([countryStateObservable, serviceInformationObservable]).subscribe({
      next: ([countryStateName, serviceInformation]) => {
        // Extract necessary data from the service information
        const isTeilunObtainableOnSite = serviceInformation?.onSiteObtaining ?? true;

        //Update the property form with the retrieved data
        propertyForm.patchValue({
          state: countryStateName,
          isTeilunObtainableOnSite
        });

        this.propertyFormComponent?.updatePropertyWithFormValues();
        this.addTeilunAgainToProperty();
        this.markPropertyDefiningInputAsPristine();
      },
      error: () => {
        // An unknown state is priced like any other, a stale one of a previous address would be priced wrong
        propertyForm.patchValue({
          state: null,
          isTeilunObtainableOnSite: true
        });
        this.propertyFormComponent?.updatePropertyWithFormValues();
        this.addTeilunAgainToProperty();
        this.markPropertyDefiningInputAsPristine();
      }
    });
  }

  /**
   * Synchronizes the current form values with the property object
   * and updates the selected property in the 'productContainerComponent'
   */
  getSelectedProperty() {
    if(this.propertyFormComponent?.propertyForm){
      Object.assign(this.property, this.propertyFormComponent.propertyForm.value)
    }
    this.property.dataResearch = this.propertyInformationForm.getRawValue().dataResearch
    this.productsContainerComponent.selectedProperty = this.property;
  }

  addTeilunAgainToProperty(){
    let index = -1;

    this.productsContainerComponent.documents.forEach((document, i) => {
      if(document.docname === "teilun"){
        index = i;
        if(index > -1){
          this.productsContainerComponent.documents.splice(index, 1);
          this.productsContainerComponent.addDocument("teilun", null);
        }
      }
    })
  }

  checkPropertyInFormManually(){
    if(!this.propertyFormComponent?.propertyForm){
      return;
    }

    let propertyForm = this.propertyFormComponent.propertyForm;

    if (propertyForm.get('zip').dirty || propertyForm.get('town').dirty || this.property.isTeilunObtainableOnSite === undefined) {
      this.markPropertyDefiningInputAsPristine()
      this.checkPropertyInForm()
    }
  }

  markPropertyDefiningInputAsPristine(){
    let propertyForm = this.propertyFormComponent.propertyForm;
    let folioFormArray = (propertyForm.get("landregisterfolios")) as UntypedFormArray

    propertyForm.get('zip').markAsPristine()
    propertyForm.get('town').markAsPristine()
    folioFormArray.controls[0].get('gemarkung').markAsPristine()
  }

    /**
     * Handles when a user wants to navigate to the next page from the new order page
     * Handles if the user is not allowed to order
     * Handles if not all information regarding products are set
     */
  public handleAddAuthorityClickEvent(event: any): void{
      if(!this.checkIfAllProductInformationArePresent()){
          event.stopPropagation();
          return;
      }
      if(!this.isAllowedToOrder){
          this.scrollToNotification();
          return;
      }
      this.addAuthority(true);
  }

    /**
     * Checks if all information regarding products are available inside the products container component
     */
    public checkIfAllProductInformationArePresent(): boolean {
        return this.productsContainerComponent && this.productsContainerComponent.areAllProductInformationPresent()
    }

  scrollToNotification() {
    window.scrollTo({top: 0, behavior: "smooth"});
  }

  /**
   * Updates the current property with the values from the given property object.
   * Ensures that landregisterfolios has at least one entry and updates the child form accordingly.
   *
   * @param {Property} property - The property object containing updated values to merge into the current property.
   */
  public updatePropertyFromMap(property: Property) {
    // Ensure incoming property has an array for landregisterfolios
    if (!property.landregisterfolios) {
      property.landregisterfolios = [];
    }
    if (property.landregisterfolios.length === 0) {
      property.landregisterfolios.push(new Landregisterfolio());
    }

    // Prepare old numbers in the structure expected by assignFolioNumbers
    const oldFolioNumbers: Array<{ number: string }> = (this.property.landregisterfolios || []).map(folio => ({
      number: folio.number ?? ''
    }));

    // Copy property name from the form
    this.property.name = this.propertyInformationForm.value.name;

    // The state is price relevant, so it has to follow every change of the address, not only the first one
    const hasAddressChanged = property.zip !== this.property.zip || property.town !== this.property.town;
    const shouldCheckProperty = hasAddressChanged || this.property.isTeilunObtainableOnSite === undefined;

    Object.assign(this.property, property);

    // Assign old numbers using the utility (handles surplus numbers automatically)
    if (this.property.landregisterfolios) {
      LandregisterfolioUtils.assignFolioNumbers(this.property.landregisterfolios, oldFolioNumbers);
    }

    // Ensure child form updates; the check reads the form, so it runs once the form holds the new address
    setTimeout(() => {
      this.propertyFormComponent?.updateFormFromProperty();
      if (shouldCheckProperty) {
        this.checkPropertyInForm();
      }
    });
  }

  /**
   * Filters the property folios by the provided parcels, retaining only the relevant data that matches the given property.
   *
   * @param {Object} params - An object containing the required parameters.
   * @param {string[]} params.validParcels - An array of valid parcel identifiers to filter against.
   * @param {string} params.propertyTempId - The temporary property ID used to match the current property.
   */
  public filterPropertyFoliosByParcels({
                                         validParcels,
                                         propertyTempId}: {
    validParcels: string[];
    propertyTempId: string; }): void {
    this.isMapLoading = false;
    if (propertyTempId !== this.property.tempId) return;

    const parcelSet = new Set(validParcels);

    this.property.landregisterfolios = (this.property.landregisterfolios ?? [])
        .map(folio => this.filterFolioByParcels(folio, parcelSet))
        .filter((folio): folio is Landregisterfolio => !!folio);

    this.propertyFormComponent?.updateFormFromProperty();
  }

  /**
   * Filters a single folio by removing flure/flurstuecke that don't match valid parcel keys.
   */
  /**
   * Filters a single folio by removing flure/flurstuecke that don't match valid parcel keys.
   * Folios with a defined number property are retained even if no flure remain.
   */
  private filterFolioByParcels(folio: Landregisterfolio, parcelSet: Set<string>): Landregisterfolio | null {
    const gemarkung = folio.gemarkung ?? '';

    const filteredFlure = (folio.flure ?? [])
        .map(flur => this.filterFlurByParcels(flur, gemarkung, parcelSet))
        .filter((flur): flur is Flur => !!flur);

    // Keep folios that have a number, even if they have no valid flure left
    if ((filteredFlure.length > 0) || folio.number != null) {
      return { ...folio, flure: filteredFlure };
    }
    // Otherwise, remove folio
    return null;
  }

  /**
   * Filters a single flur by removing flurstuecke that don't match valid parcel keys.
   */
  private filterFlurByParcels(flur: Flur, gemarkung: string, parcelSet: Set<string>): Flur | null {
    const flurNumber = flur.number ?? '';

    const filteredFlurstuecke = (flur.flurstuecke ?? []).filter(flurstueck => {
      const flurstueckNumber = flurstueck.number ?? '';
      const key = this.buildParcelKey(gemarkung, flurNumber, flurstueckNumber);
      return parcelSet.has(key);
    });

    return filteredFlurstuecke.length > 0 ? { ...flur, flurstuecke: filteredFlurstuecke } : null;
  }

  /**
   * Constructs a unique parcel key string from gemarkung, flur number, and flurstueck number.
   */
  private buildParcelKey(gemarkung: string, flurNumber: string, flurstueckNumber: string): string {
    return `${gemarkung}_${flurNumber}_${flurstueckNumber}`;
  }

  /**
   * Determines if the property has a complete address by checking the presence of street, house number, zip, and town.
   *
   * @return {boolean} Returns true if all address components (street, house number, zip, and town) exist, otherwise false.
   */
  get hasFullAddress(): boolean {
    if(!this.property){
      return false;
    }
    const { street, zip, town } = this.property;
    return [street, zip, town].every(
        part => !!part && part.trim().length > 0
    );
  }

  /**
   * Updates the manual data input state and synchronizes related properties and form values.
   *
   * @param {boolean} isManualInput - Indicates whether the input is manual or not.
   * @param {boolean} [triggerPropertySync=true] - Determines if the property synchronization process should be triggered.
   * @param {boolean} [dataResearchValue=isManualInput] - The value to be set for the data research property.
   */
  public updateManualDataInput(isManualInput: boolean, triggerPropertySync: boolean = true, dataResearchValue: boolean = isManualInput): void {
    // If switching from manual to map input, persist the form values into the property model to ensure the updated values are displayed on the map
    if(!isManualInput){
      this.propertyFormComponent.updatePropertyWithFormValues()
    }

    this.isManualObjectDataInput = isManualInput;

    this.property.dataSource = isManualInput ? 'manual' : 'map';
    this.property.dataResearch = dataResearchValue;
    this.property.name = this.propertyInformationForm.get('name').value;
    this.propertyInformationForm.patchValue({ dataResearch: dataResearchValue });

    const dataResearchControl = this.propertyInformationForm.get('dataResearch');
    isManualInput ? dataResearchControl?.disable({emitEvent: false, onlySelf: true}) : dataResearchControl?.enable({emitEvent: false, onlySelf: true});

    if (triggerPropertySync) {
      this.propertyFormComponent.updateFormFromProperty();
      this.getSelectedProperty();
    }
  }

  /**
   * Updates the map data by sending relevant property information to the parcel map component's iframe.
   * This includes setting the map center based on location coordinates, along with updating the search value and parcel details.
   * The method only operates when the property has a full address and the parcel map component is initialized.
   *
   * @return {void} Does not return a value.
   */
  public updateMapData(): void{
    if(!this.hasFullAddress || !this.parcelMapComponent){
      return;
    }

    const {street = '', house_number = '', zip = '', town = '', location, landregisterfolios} = this.property;
    const searchValue = `${street} ${house_number}, ${zip} ${town}`.trim();
    const parcels = this.buildFolioParcelStrings(landregisterfolios);
    const contentWindow = this.parcelMapComponent.iframe.nativeElement.contentWindow;

    if(location?.lat && location?.lng){
      contentWindow.postMessage({type: 'setCenter', payload: {lat: this.property.location?.lat, lng: this.property.location?.lng, zoom: 18, duration: 100}}, '*');
    }
    contentWindow.postMessage({type: 'setSearchValue', payload: {searchValue: searchValue, parcels: parcels, propertyTempId: this.property.tempId}}, '*')
  }

  /**
   * Builds parcel identifier strings from land register folios.
   * Each string has the format: gemarkung_flurNumber_flurstueckNumber.
   * Entries with missing parts are skipped.
   *
   * @param folios - The list of Landregisterfolio objects.
   * @returns An array of parcel identifier strings.
   */
  private buildFolioParcelStrings(folios: Landregisterfolio[]): string[] {
    const result: string[] = [];

    for (const folio of folios) {
      const gemarkung = folio.gemarkung?.trim();
      if (!gemarkung) continue;

      for (const flur of folio.flure ?? []) {
        const flurNumber = flur.number?.trim();

        for (const flurstueck of flur.flurstuecke ?? []) {
          const flurstueckNumber = flurstueck.number?.trim();
          if (!flurstueckNumber) continue;

          result.push(`${gemarkung}_${flurNumber}_${flurstueckNumber}`);
        }
      }
    }

    return result;
  }

  /**
   * Loads properties from the session storage key "new_order_properties" and assigns them to the properties property.
   * If no properties are found in session storage, it assigns an empty array.
   */
  private loadPropertiesFromSession(): void{
    const storedProperties = sessionStorage.getItem("new_order_properties");
    this.properties = storedProperties ? JSON.parse(storedProperties) : [];
  }

  /**
   * Handles the initial selection of a property. If the properties array is not empty, the first property is selected and triggers the property selection handler.
   * If no property is available, a new Property instance is created and assigned.
   */
  private handleInitialPropertySelection(): void{
    if (this.properties.length > 0) {
      this.property = this.properties[0]
      this.onPropertySelection(this.property);
    }

    // Ensure a property is always defined
    if (!this.property) {
      this.property = new Property('map');
    }
  }

  /**
   * Initializes and sets up the property information form with default values and validators.
   * Also, subscribes to changes in the 'dataResearch' field to update the corresponding property value.
   */
  private initializePropertyInformationForm(): void{
    this.propertyInformationForm = this.formBuilder.group({
      dataResearch: [this.property?.dataResearch ?? false],
      name: [this.property?.name ?? '', Validators.maxLength(500)]
    });

    this.propertyInformationForm.get('dataResearch')?.valueChanges.subscribe((value: boolean) => {
      if (this.property) {
        this.property.dataResearch = value;
      }
    });
  }

  /**
   * Opens the information modal if the "informationPopup" flag is not set in local storage.
   * The modal uses the `InformationPopupComponent` with specific configurations.
   */
  public openInformationModal(forceOpen: boolean = false): void {
    const showInformationPopup = localStorage.getItem('informationPopup');

    if (!showInformationPopup || forceOpen) {
      this.dialog.open(InformationPopupComponent, {
        width: 'auto',
        panelClass: ['has-round-border', 'overflow-dialog'],
        disableClose: true,
      });
    }
  }

  /**
   * Updates the property form by patching specific values and invoking further updates
   * in the associated form component.
   */
  public updatePropertyForm(){
    if(!this.isManualObjectDataInput){
      this.propertyInformationForm.patchValue({
        dataResearch: this.property?.dataResearch ?? false
      })
    }
  }
}
